export const ORGANIZATION_DATA = {
  '@type': 'Organization',
  name: 'Madpaws.com.au',
  alternateName: 'Madpaws',
  url: 'https://www.madpaws.com.au',
  logo: 'https://www.madpaws.com.au/static/logo-dark.png',
  sameAs: [
    'https://www.facebook.com/madpawsau',
    'https://twitter.com/madpawsau',
    'http://instagram.com/madpawsau',
    'https://www.youtube.com/channel/UCYQWI-l7sYntZvtPH-zM8HA/feed',
  ],
};
